export default __webpack_public_path__ + "static/media/22.621f37d0.jpg";